exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main-logo img{width:192px;height:auto;display:inline-block;vertical-align:top}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b03b931","scoped":false,"hasInlineConfig":true}!./src/components/main-logo/main-logo.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-3b03b931","scoped":false,"hasInlineConfig":true}!./src/components/main-logo/main-logo.css
// module chunks = index